import {
    call,
    takeEvery
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import PaymentFactory from "../../Entity/Factories/PaymentFactory";

export default function* getMatchedPaymentsList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `charge/${action?.payload?.chargeId}/getMatchedPayments`);

    const payments = res?.data?.map(charge => {
      return PaymentFactory.create(charge);
    });

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, payments);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchGetMatchedPaymentsList() {
  yield takeEvery(Constants.GLOBAL_GET_MATCHED_PAYMENTS_LIST, getMatchedPaymentsList);
}
